<template>
  <v-dialog v-model="dialog" max-width="600" persistent>
    <v-card>
      <v-toolbar color="primary" dark>
        <v-toolbar-title>{{ $t('user_management.edit_user_settings') }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark icon @click="dialog = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-form ref="form">
          <!--            :rules="[$rules.required, $rules.email, $rules.spacesNotAllowed]"-->
          <v-text-field
            v-model="currentUser.email"
            :disabled="true"
            :label="$t('user_management.email')"
            autocomplete="username"
            class="mt-5 email"
            type="text"
            validate-on-blur
          ></v-text-field>

          <v-text-field
            v-model="currentUser.firstName"
            :label="$t('user_management.first_name')"
            class="mt-5 firstname"
            type="text"
            validate-on-blur
          ></v-text-field>

          <v-text-field
            v-model="currentUser.lastName"
            :label="$t('user_management.last_name')"
            class="mt-5 lastname"
            type="text"
            validate-on-blur
          ></v-text-field>

          <v-text-field
            v-model="currentUser.phone"
            :label="$t('user_management.phone')"
            class="mt-5 phone"
            type="tel"
            validate-on-blur
          ></v-text-field>
        </v-form>

        <v-alert :value="showAlert" class="mt-4" outlined type="error">{{
            $t('validation.check_all_required_fields')
          }}.
        </v-alert>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions :class="$vuetify.breakpoint.xsOnly ? 'flex-column-reverse' : ''">
        <v-spacer></v-spacer>
        <v-btn
          :block="$vuetify.breakpoint.xsOnly"
          :disabled="saving"
          :large="$vuetify.breakpoint.xsOnly"
          class="ma-1"
          color="default"
          @click="dialog = false"
        >
          <v-icon left>close</v-icon>
          <span>{{ $t('cancel') }}</span>
        </v-btn>
        <v-btn
          :block="$vuetify.breakpoint.xsOnly"
          :large="$vuetify.breakpoint.xsOnly"
          :loading="saving"
          class="ma-1"
          color="primary"
          @click="saveUser"
        >
          <v-icon left>check</v-icon>
          <span>{{ $t('save') }}</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import adminApi from '../../api/admin';

export default {
  name: 'UserDetailsDialog',
  data() {
    return {
      dialog: false,
      saving: false,
      currentUser: {},
      showAlert: false,
    };
  },
  methods: {
    async saveUser() {
      if (!this.$refs.form.validate()) {
        this.showAlert = true;
        return;
      }

      this.saving = true;

      try {
        await adminApi.updateUser(this.currentUser.subject, {
          firstName: this.currentUser.firstName,
          lastName: this.currentUser.lastName,
          phone: this.currentUser.phone,
        });
        this.dialog = false;
        this.$showSuccessNotification(this.$t('user_management.user_info_updated'));
      } catch (err) {
        this.$handleApiError(this.$t('user_management.user_info_update_failed'));
      }
      this.saving = false;
    },
    openUser(user) {
      this.dialog = true;
      this.currentUser = Object.assign({}, user);
    },
  },
  watch: {
    dialog(value) {
      if (!value) {
        this.showAlert = false;
        this.$refs.form.reset();
        this.currentUser = {};
        this.$emit('on-dismiss');
      }
    },
  },
};
</script>

<style scoped></style>
